import axios from 'axios';

const headers = {
    Accept: 'application/json',
    'Content-type': 'application/json',
    'Accept-Language': 'es',
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: '0'
};

export default axios.create({
    withCredentials: true,
    baseURL: import.meta.env.REACT_APP_LOGIN_API_URL,
    responseType: 'json',
    headers
});
